"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Order = void 0;
const GetOrderDetails_1 = require("./GetOrderDetails");
const PostOrderCreate_1 = require("./PostOrderCreate");
__exportStar(require("./GetOrderDetails"), exports);
__exportStar(require("./PostOrderCreate"), exports);
exports.Order = {
    GetDetails: GetOrderDetails_1.GetOrderDetails,
    PostCreate: PostOrderCreate_1.PostOrderCreate
};
//# sourceMappingURL=index.js.map